
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6a64"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6a64"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("6Vrnd", function(module, exports) {
/*
 * Panels 0.1
 */ // ES-5 15.3.4.5
// http://es5.github.com/#x15.3.4.5
if (!Function.prototype.bind) {
    var slice = Array.prototype.slice;
    Function.prototype.bind = function bind11(that11) {
        var target11 = this;
        if (typeof target11 != "function") throw new TypeError("Function.prototype.bind called on incompatible " + target11);
        var args11 = slice.call(arguments, 1); // for normal call
        var bound11 = function() {
            if (this instanceof bound11) {
                var F11 = function() {};
                F11.prototype = target11.prototype;
                var self11 = new F11;
                var result11 = target11.apply(self11, args11.concat(slice.call(arguments)));
                if (Object(result11) === result11) return result11;
                return self11;
            } else return target11.apply(that11, args11.concat(slice.call(arguments)));
        };
        return bound11;
    };
}
(function() {
    "use strict";
    var root = this;
    var Panels = root.Panels = {};
    var $ = root.jQuery || root.Zepto || root.ender;
    // we extend Backbone.history a bit
    Backbone.history.pause = function() {
        if (this.paused || !Backbone.History.started) return false;
        this.paused = true;
        Backbone.History.started = false;
        this.checkUrlBackup = this.checkUrl;
        this.checkUrl = function() {};
        return true;
    };
    Backbone.history.resume = function() {
        if (!this.paused) return false;
        this.checkUrl = this.checkUrlBackup;
        delete this.checkUrlBackup;
        Backbone.History.started = true;
        delete this.paused;
        return true;
    };
    Panels.App = Backbone.Router.extend({
        constructor: function(options11) {
            if (!options11) options11 = {};
            if (options11.root) this.root = options11.root;
            if ((location.search || "").substr(0, 4) === "?_ga" && window.history) history.replaceState(null, null, "/");
            for(var i11 in this.states)this.routePanel(i11, this.states[i11]);
            //this.routePanel('*path', 'Panels.StaticPanel');
            var initialize11 = this.initialize;
            this.initialize = function() {};
            Backbone.Router.prototype.constructor.apply(this, arguments);
            // constructor
            this.panels = [];
            this.popups = [];
            initialize11.apply(this, arguments);
            Backbone.history.start({
                root: this.root,
                pushState: true,
                hashChange: false
            });
            this.fragment = Backbone.history.fragment;
            $(window).resize((function() {
                this.resize();
            }).bind(this));
        },
        root: "/",
        fragment: "",
        states: {},
        panels: null,
        i: 0,
        j: 0,
        topbarView: null,
        topbar: null,
        topbarHeight: 0,
        goLeftWidth: 35,
        goRightWidth: 35,
        goLeftRightDelay: 300,
        goLeftWidthOffset: 0,
        goRightWidthOffset: 0,
        backButtonPrefix: "",
        // routing functions
        go: function(fragment11, loc11, replace11, source11, instant11) {
            if (fragment11 && fragment11.substr(0, this.root.length) === this.root) fragment11 = fragment11.substr(this.root.length);
            // no matter what, if the panel exists, we're going straight to it
            var i11 = this.getFragmentIndex(fragment11);
            if (i11 >= 0) {
                if (i11 >= this.j && i11 <= this.i) this.focusPanel(i11, instant11, true); // already in view; maximize it
                else this.scrollIntoView(i11, instant11);
                this.updateURL();
                return;
            }
            if (typeof loc11 !== "number") {
                loc11 = this.panels.indexOf(loc11);
                if (loc11 < 0) loc11 = null;
                else if (!replace11) loc11++;
            }
            this.goLoc = loc11;
            this.goLocReplace = replace11;
            this.goLocSource = source11;
            this.goInstant = instant11;
            //this.navigate(fragment, {trigger: true});
            Backbone.history.loadUrl(fragment11);
        },
        getPanelIndex: function(panel11) {
            for(var i11 = this.panels.length - 1; i11 >= 0; i11--){
                if (this.panels[i11] === panel11) return i11;
            }
            return -1;
        },
        getFragmentIndex: function(fragment11) {
            for(var i11 = this.panels.length - 1; i11 >= 0; i11--){
                if (this.panels[i11] && this.panels[i11].fragment === fragment11) return i11;
            }
            return -1;
        },
        slicePanelLeft: function() {
            while(this.j){
                var panel11 = this.panels.shift();
                panel11.remove();
                this.j--;
            }
            this.i = this.j;
        },
        navigatePanel: function(name11, fragment11, args11) {
            if (!this.panels.length) {
                this.initializePanels(name11, fragment11, args11);
                return;
            }
            var isInternal11 = "goLoc" in this;
            var loc11 = this.goLoc;
            var instant11 = this.goInstant;
            delete this.goLoc;
            delete this.goInstant;
            var i11 = this.getFragmentIndex(fragment11);
            if (i11 >= 0) {
                this.focusPanel(i11, instant11);
                this.updateURL(!isInternal11);
                return;
            }
            if (loc11 === undefined) loc11 = this.panels.length - 1;
            var left11 = false;
            if (loc11 < 0) {
                // insert leftmost
                var $el11 = $('<div class="pfx-panel"></div>');
                $el11.insertBefore(this.panels[0].el);
                this.panels.unshift(null);
                this.i++;
                loc11 = 0;
            } else {
                // insert at loc
                var $el11 = $('<div class="pfx-panel"></div>');
                $el11.insertAfter(this.lastPanel().el);
                while(this.panels.length > loc11){
                    var panel11 = this.panels.pop();
                    left11 = panel11.left;
                    panel11.remove();
                }
                this.panels.push(null);
            }
            this.renderPanel(loc11, name11, {
                el: $el11[0],
                fragment: fragment11,
                args: args11,
                source: this.goLocSource,
                sourcePanel: this.panels[loc11 - 1]
            });
            if (!loc11) {
                var leftPanel11 = this.panels[loc11];
                var rightPanel11 = this.panels[loc11 + 1];
                if (rightPanel11) leftPanel11.whenLoaded(function() {
                    var source11 = leftPanel11.$('a[href="' + this.root + rightPanel11.fragment + '"]');
                    // console.log('sources: a[href="'+this.root+rightPanel.fragment+'"] ('+source.length+')');
                    if (!source11.length) source11 = null;
                    rightPanel11.setSource(source11, leftPanel11);
                });
            }
            if (left11 !== false) {
                if (this.i > loc11) this.i = loc11;
                if (this.i == loc11) this.panels[loc11].moveTo([
                    left11,
                    "auto",
                    0
                ], {}, true);
                if (left11) this.panels[loc11].targetLeft = left11;
            }
            this.scrollIntoView(loc11, instant11);
            this.updateURL(!isInternal11);
        },
        updateURL: function(noPush11) {
            var fragment11 = this.panels[this.i].fragment;
            if (fragment11 === this.fragment) return;
            this.fragment = fragment11;
            if (root.ga) ga("send", "pageview", Backbone.history.root + fragment11);
            if (noPush11) return;
            // console.log('URL update: '+fragment);
            // loadUrl updates the fragment, which prevents us from doing actual fragment manipulation
            Backbone.history.fragment = "??forceupdate";
            Backbone.history.navigate(fragment11);
        },
        slicePanel: function(panel11) {
            if (!this.panels.length) {
                this.initializePanels(name, fragment, args);
                return;
            }
            var loc11 = this.getPanelIndex(panel11);
            if (loc11 < 0) return;
            delete this.goLoc;
            if (this.i > loc11) this.i = loc11;
            if (this.j > loc11) this.j = loc11;
            while(this.panels.length > loc11 + 1){
                var panel11 = this.panels.pop();
                panel11.remove();
            }
            this.scrollIntoView(loc11, true);
            this.updateURL();
        },
        setPanelSource: function() {
            var source11 = leftPanel.$('a[href="' + this.root + rightPanel.fragment + '"]');
            // console.log('sources: a[href="'+this.root+rightPanel.fragment+'"] ('+source.length+')');
            if (!source11.length) source11 = null;
            rightPanel.setSource(source11, leftPanel);
        },
        resize: function() {
            this.calculateLayout();
            this.commitLayout(true);
        },
        focusPanel: function(index11, instant11, limit111) {
            // scroll so that panel at index is rightmost
            instant11 = !this.calculateLayout(index11, limit111) || instant11;
            this.commitLayout(instant11);
        },
        scrollIntoView: function(index11, instant11) {
            // scroll so that panel at index is in view
            if (index11 >= this.i) this.focusPanel(index11, instant11);
            else {
                var i11 = this.i + 1;
                do {
                    i11--;
                    this.calculateLayout(i11);
                }while (this.targetJ > index11 && i11 > 0);
                this.commitLayout(instant11);
            }
        },
        routePanel: function(route11, name11) {
            Backbone.history || (Backbone.history = new Backbone.History);
            if (!_.isRegExp(route11)) route11 = this._routeToRegExp(route11);
            Backbone.history.route(route11, _.bind(function(fragment11) {
                this.midRouting = true;
                var args11 = this._extractParameters(route11, fragment11);
                this.navigatePanel.call(this, name11, fragment11, args11);
                this.trigger.apply(this, [
                    "route:" + name11
                ].concat(args11));
                Backbone.history.trigger("route", this, name11, args11);
                this.midRouting = false;
            }, this));
            return this;
        },
        lastPanel: function() {
            return this.panels[this.panels.length - 1];
        },
        reloadPanels: function() {
            for(var i11 = 0, len11 = this.panels.length; i11 < len11; i11++)this.panels[i11].reload();
        },
        // popups
        popups: null,
        addPopup: function(type11, options11) {
            if (!options11) options11 = {};
            type11 = this.getPanelType(type11);
            var bgElem11 = $('<div class="pfx-popup-bg"></div>');
            bgElem11.insertAfter(this.lastPanel().el);
            options11.bgElem = bgElem11;
            bgElem11.on("click", this.closePopup.bind(this));
            var elem11 = $('<div class="pfx-popup"></div>');
            elem11.insertAfter(bgElem11);
            options11.el = elem11;
            if (options11.source) {
                // attach to a specific element
                var style11 = {
                    position: "absolute"
                };
                var source11 = $(options11.source);
                var sourceOffset11 = source11.offset();
                var sourceY111 = sourceOffset11.top;
                var sourceY211 = sourceY111 + source11.outerHeight();
                var viewportY111 = $(window).scrollTop();
                var viewportY211 = viewportY111 + $(window).height();
                if (sourceY111 - viewportY111 > viewportY211 - sourceY211) // more room on top
                style11.bottom = $(document).height() - sourceY111;
                else style11.top = sourceY211;
                var sourceX111 = sourceOffset11.left;
                var sourceX211 = sourceX111 + source11.outerWidth();
                var viewportX111 = $(window).scrollLeft();
                var viewportX211 = viewportX111 + $(window).width();
                if (sourceX111 - viewportX111 > viewportX211 - sourceX211) // more room to the left
                style11.right = $(document).width() - sourceX211;
                else style11.left = sourceX111;
                elem11.css(style11);
            }
            options11.app = this;
            this.popups.push(new type11(options11));
        },
        closePopup: function() {
            if (!this.popups.length) return;
            var popup11 = this.popups.pop();
            popup11.remove();
        },
        // panel animation
        getPanelType: function(name) {
            if (typeof name === "string") // var nameSplit = name.split('.');
            // name = window;
            // for (var i=0, len=nameSplit.length; i<len; i++) {
            // 	name = name[nameSplit[i]];
            // }
            return eval(name);
            return name;
        },
        /**
		 * Initialize the entire app: Set up all the views.
		 */ renderPanel: function(index11, panelType11, options11, first11) {
            if (first11) $(options11.el).css({
                position: "absolute",
                top: this.topbarHeight,
                left: 0,
                right: 0,
                bottom: 0,
                width: "auto",
                height: "auto",
                "-webkit-overflow-scrolling": "touch",
                "overflow-scrolling": "touch",
                overflow: "auto"
            });
            else $(options11.el).css({
                position: "absolute",
                top: this.topbarHeight,
                left: 0,
                right: "auto",
                bottom: 0,
                width: "auto",
                height: "auto",
                "-webkit-overflow-scrolling": "touch",
                "overflow-scrolling": "touch",
                overflow: "auto"
            });
            panelType11 = this.getPanelType(panelType11);
            options11.app = this;
            return this.panels[index11] = new panelType11(options11);
        },
        /**
		 * Initialize the entire app: Set up all the views.
		 */ initializePanels: function(name11, fragment11, args11) {
            // global
            $("body").css({
                overflow: "hidden"
            });
            // topbar
            if (!this.topbarView) this.topbarView = Panels.Topbar;
            this.topbarView = this.getPanelType(this.topbarView);
            var topbarElem11 = $(".pfx-topbar");
            if (topbarElem11.length) {
                topbarElem11.css({
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0
                });
                this.topbar = new this.topbarView({
                    el: topbarElem11[0],
                    app: this
                });
                this.topbarHeight = this.topbar.height;
            }
            var $panels11 = $(".pfx-panel");
            this.panels = new Array($panels11.length);
            var first11 = true;
            // iterate right-to-left
            for(var i11 = $panels11.length - 1; i11 >= 0; i11--){
                var el11 = $panels11[i11];
                var panel11 = this.renderPanel(i11, name11, {
                    el: el11,
                    fragment: fragment11,
                    args: args11,
                    loaded: true
                }, first11);
                if (i11) {
                    name11 = panel11.parentName;
                    fragment11 = panel11.parentFragment;
                    args11 = panel11.parentArgs;
                }
                first11 = false;
            }
            this.i = this.panels.length - 1;
            this.calculateLayout(this.i);
            this.commitLayout(true);
        },
        calculateLayout: function(loc11, limit111) {
            if (loc11 === undefined) loc11 = this.i;
            this.targetI = loc11;
            var panels11 = this.panels;
            var maxWidth11 = $("body").width();
            var curWidth11 = 0;
            var curBuffer11 = 0;
            var numPanels11 = 0;
            var hasSidebar11 = false;
            var left11 = 0;
            var layoutChanged11 = !!(this.i !== loc11);
            this.targetWidth = maxWidth11;
            var goRightWidth11 = this.goRightWidth || 0;
            var goLeftWidth11 = this.goLeftWidth || 0;
            if (loc11 >= this.panels.length - 1) goRightWidth11 = 0;
            maxWidth11 -= goRightWidth11;
            // find out how many panels there are
            do {
                var width11 = panels11[loc11].minWidth;
                var buffer11 = panels11[loc11].maxWidth - width11;
                if (numPanels11 && curWidth11 + width11 > maxWidth11 - (loc11 ? goLeftWidth11 : 0)) break;
                curWidth11 += width11;
                curBuffer11 += buffer11;
                numPanels11++;
                loc11--;
            }while (!limit111 && panels11[loc11]);
            if (!limit111 && numPanels11 <= 1 && panels11[loc11] && panels11[loc11].sidebarWidth) // no room for more than one full panel, but maybe a sidebar will fit
            {
                if (curWidth11 + panels11[loc11].sidebarWidth <= maxWidth11 - (loc11 ? goLeftWidth11 : 0)) {
                    var targetWidth11 = panels11[loc11].sidebarWidth + curBuffer11;
                    if (panels11[loc11].targetWidth !== undefined && panels11[loc11].targetWidth !== targetWidth11) layoutChanged11 = true;
                    panels11[loc11].targetWidth = targetWidth11;
                    curWidth11 += targetWidth11;
                    curBuffer11 = 0;
                    numPanels11++;
                    loc11--;
                    hasSidebar11 = true;
                }
            }
            this.targetJ = loc11 + 1;
            if (loc11 + 1 <= 0) goLeftWidth11 = 0;
            if (loc11 + 1 == this.targetI) {
                maxWidth11 += goRightWidth11;
                goRightWidth11 = 0;
                goLeftWidth11 = 0;
            }
            maxWidth11 -= goLeftWidth11;
            // calculate our buffer ratio
            var maxBuffer11 = maxWidth11 - curWidth11;
            if (maxBuffer11 > curBuffer11) {
                left11 = Math.floor((maxBuffer11 - curBuffer11) / 2);
                maxBuffer11 = curBuffer11;
            }
            var bufferRatio11 = curBuffer11 ? maxBuffer11 / curBuffer11 : 1;
            // calculate gaps
            this.targetRightGap = goRightWidth11 ? left11 + goRightWidth11 : 0;
            this.targetLeftGap = goLeftWidth11 ? left11 + goLeftWidth11 : 0;
            left11 += goLeftWidth11;
            // populate panel layout
            // visible panels
            for(var i11 = loc11 + 1, max11 = this.targetI; i11 <= max11; i11++){
                var panel11 = panels11[i11];
                if (panel11.targetLeft !== undefined && panel11.targetLeft !== left11) layoutChanged11 = true;
                panel11.targetLeft = left11;
                if (hasSidebar11 && i11 == loc11 + 1) ;
                else {
                    var targetWidth11 = Math.floor(panel11.minWidth + bufferRatio11 * (panel11.maxWidth - panel11.minWidth));
                    if (panel11.targetWidth !== undefined && panel11.targetWidth !== targetWidth11) layoutChanged11 = true;
                    panel11.targetWidth = targetWidth11;
                }
                left11 += panel11.targetWidth;
            }
            return layoutChanged11;
        },
        getDestLoc: function(panel11, i11) {
            if (typeof panel11 === "number") {
                i11 = panel11;
                panel11 = this.panels[i11];
            }
            var left11 = panel11.targetLeft;
            var width11 = panel11.targetWidth;
            var right11 = "auto";
            if (i11 == this.targetJ) {
                width11 += left11 - this.targetLeftGap;
                left11 = this.targetLeftGap;
            }
            if (i11 == this.targetI) {
                right11 = this.targetRightGap;
                width11 = "auto";
            }
            return [
                left11,
                width11,
                right11
            ];
        },
        getPanelWidth: function(panel11) {
            if (panel11.width === "auto") return this.targetWidth - panel11.left - panel11.right;
            return panel11.width;
        },
        commitLayout: function(instant11) {
            var goingBack11 = this.targetI < this.i || this.targetI === this.i && this.targetJ < this.j;
            if (goingBack11) {
                // <--
                var totalWidth11 = this.targetWidth - this.targetRightGap;
                for(var i11 = Math.max(this.j, this.targetI + 1), end11 = this.i; i11 <= end11; i11++){
                    //console.log('going right offscreen: '+i);
                    this.panels[i11].moveTo([
                        totalWidth11,
                        this.getPanelWidth(this.panels[i11]),
                        "auto"
                    ], {
                        hide: true
                    }, instant11);
                    totalWidth11 += this.getPanelWidth(this.panels[i11]);
                }
                for(var i11 = this.targetI, end11 = this.j; i11 >= end11; i11--)//console.log('moving right: '+i);
                this.panels[i11].moveTo(this.getDestLoc(i11), {
                    leftmost: this.targetJ == i11,
                    rightmost: this.targetI == i11,
                    time: this.goLeftRightDelay
                }, instant11);
                totalWidth11 = this.targetLeftGap;
                for(var i11 = Math.min(this.j - 1, this.targetI), end11 = this.targetJ; i11 >= end11; i11--){
                    //console.log('coming from left: '+i);
                    totalWidth11 -= this.panels[i11].targetWidth;
                    this.panels[i11].moveTo(this.getDestLoc(i11), {
                        leftmost: this.targetJ == i11,
                        rightmost: this.targetI == i11,
                        startingOffset: totalWidth11 - this.panels[i11].targetLeft,
                        time: this.goLeftRightDelay
                    }, instant11);
                }
            } else {
                // -->
                var totalWidth11 = -this.targetLeftGap;
                for(var i11 = Math.min(this.i, this.targetJ - 1), end11 = this.j; i11 >= end11; i11--){
                    //console.log('going left offscreen: '+i);
                    totalWidth11 += this.getPanelWidth(this.panels[i11]);
                    this.panels[i11].moveTo([
                        -totalWidth11,
                        this.getPanelWidth(this.panels[i11]),
                        "auto"
                    ], {
                        hide: true
                    }, instant11);
                }
                for(var i11 = this.targetJ, end11 = this.i; i11 <= end11; i11++)//console.log('moving left: '+i);
                this.panels[i11].moveTo(this.getDestLoc(i11), {
                    leftmost: this.targetJ == i11,
                    rightmost: this.targetI == i11,
                    time: this.goLeftRightDelay
                }, instant11);
                totalWidth11 = this.targetWidth - this.targetRightGap;
                for(var i11 = Math.max(this.i + 1, this.targetJ), end11 = this.targetI; i11 <= end11; i11++){
                    //console.log('coming from right: '+i);
                    this.panels[i11].moveTo(this.getDestLoc(i11), {
                        leftmost: this.targetJ == i11,
                        rightmost: this.targetI == i11,
                        startingOffset: totalWidth11 - this.panels[i11].targetLeft,
                        time: this.goLeftRightDelay
                    }, instant11);
                    totalWidth11 += this.panels[i11].targetWidth;
                }
            }
            this.i = this.targetI;
            this.j = this.targetJ;
            if (this.goLeftRightElem) this.goLeftRightElem.html("");
            else {
                this.goLeftRightElem = $("<div></div>");
                this.goLeftRightElem.insertAfter(this.lastPanel().el);
                this.goLeftRightElem.on("click", "a", (function(e11) {
                    e11.preventDefault();
                    e11.stopPropagation();
                    this.go($(e11.currentTarget).attr("href"));
                }).bind(this));
            }
            var buffer11 = "";
            if (this.targetLeftGap) buffer11 += '<a class="pfx-go-left" style="width:' + (this.targetLeftGap + this.goLeftWidthOffset) + 'px" href="' + this.root + this.panels[this.j - 1].fragment + '"></a>';
            if (this.targetRightGap) buffer11 += '<a class="pfx-go-right" style="width:' + (this.targetRightGap + this.goRightWidthOffset) + 'px" href="' + this.root + this.panels[this.i + 1].fragment + '"></a>';
            if (buffer11) {
                if (instant11) {
                    this.goLeftRightElem.html(buffer11);
                    this.goLeftRightElem.show();
                } else {
                    this.goLeftRightElem.hide();
                    this.goLeftRightElem.html(buffer11);
                    setTimeout((function() {
                        this.goLeftRightElem.show();
                    }).bind(this), this.goLeftRightDelay);
                }
            }
        }
    });
    var View = Panels.View = Backbone.View;
    var Panel = Panels.Panel = View.extend({
        constructor: function(options11) {
            if (!options11) options11 = {};
            this.app = options11.app;
            if (!this.events) this.events = {};
            if (!this.events["click a, button"]) this.events["click a, button"] = "handleNavigation";
            if (!this.events["submit form"]) this.events["submit form"] = "handleNavigation";
            if (options11.source) this.source = $(options11.source);
            if (options11.sourcePanel) this.sourcePanel = options11.sourcePanel;
            if (options11.bgElem) this.bgElem = options11.bgElem;
            this.loaded = !!options11.loaded;
            this.fragment = options11.fragment;
            var args11 = options11.args;
            delete options11.app;
            delete options11.loaded;
            delete options11.source;
            delete options11.bgElem;
            delete options11.fragment;
            delete options11.args;
            var initialize11 = this.initialize;
            this.initialize = function() {};
            View.prototype.constructor.call(this, options11);
            // constructor
            if (this.source) {
                this.source.addClass("cur");
                if (this.source[0].tagName.toUpperCase() === "BUTTON") this.source[0].disabled = true;
            }
            initialize11.apply(this, args11);
            if (!this.loaded) this.load();
            else this.whenLoadedQueueFlush();
            this.updateBackButton();
            this.updateContent();
        },
        source: null,
        minWidth: 480,
        maxWidth: 720,
        leftOffset: 0,
        widthOffset: 0,
        rightOffset: 0,
        fragment: "",
        hidden: false,
        setFragment: function(fragment11) {
            this.fragment = fragment11;
            this.app.updateURL();
        },
        moveTo: function(loc11, flags11, instant11) {
            var left11 = loc11[0];
            var width11 = loc11[1];
            var right11 = loc11[2];
            if (!flags11) flags11 = {};
            if (flags11.leftmost) this.$(".pfx-backbutton").show();
            else this.$(".pfx-backbutton").hide();
            this.leftmost = flags11.leftmost;
            this.rightmost = flags11.rightmost;
            this.hidden = !!flags11.hide;
            var oldLeft11 = this.left;
            var oldWidth11 = this.width;
            var oldRight11 = this.right;
            this.left = left11;
            this.width = width11;
            this.right = right11;
            if (left11 !== "auto") left11 += this.leftOffset;
            if (width11 !== "auto") width11 += this.widthOffset;
            if (right11 !== "auto") right11 += this.rightOffset;
            if (instant11) {
                this.$el.css({
                    display: flags11.hide ? "none" : "block",
                    left: left11,
                    width: width11,
                    right: right11
                });
                this.$(".pfx-body").css({
                    "margin-left": this.left ? 0 : "auto",
                    "margin-right": this.right ? 0 : "auto",
                    "max-width": this.maxWidth
                });
            } else {
                this.show();
                if (left11 === "auto") this.$el.css("left", "auto");
                if (width11 === "auto") this.$el.css("width", "auto");
                if (right11 === "auto") this.$el.css("right", "auto");
                if (flags11.startingOffset !== undefined) this.$el.css({
                    left: left11 === "auto" ? left11 : left11 + flags11.startingOffset,
                    width: width11,
                    right: right11 === "auto" ? right11 : right11 - flags11.startingOffset
                });
                else if (width11 !== "auto" && oldWidth11 === "auto") this.$el.css("width", $("body").width() - oldLeft11 - oldRight11 + this.widthOffset);
                else if (right11 !== "auto" && oldRight11 === "auto") this.$el.css("right", $("body").width() - oldLeft11 - oldWidth11 + this.rightOffset);
                this.$el.transition({
                    left: left11,
                    width: width11,
                    right: right11
                }, flags11.time || 300, function() {
                    if (flags11.hide) $(this).css("display", "none");
                });
                // left/right padding
                var elWidth11 = this.$el.width();
                var marginLeft11 = elWidth11 - this.maxWidth;
                if (marginLeft11 < 0 || oldLeft11 && !oldRight11) marginLeft11 = 0;
                else if (!(!oldLeft11 && oldRight11)) marginLeft11 = Math.floor(marginLeft11 / 2);
                var marginRight11 = elWidth11 - this.maxWidth;
                if (marginRight11 < 0 || !oldLeft11 && oldRight11) marginRight11 = 0;
                else if (!(oldLeft11 && !oldRight11)) marginRight11 = Math.floor(marginRight11 / 2);
                if (marginLeft11 && marginRight11 && this.left && this.right) marginLeft11 = 0, marginRight11 = 0;
                var $panelBody11 = this.$(".pfx-body");
                $panelBody11.css({
                    "margin-left": this.left ? marginLeft11 : "auto",
                    "margin-right": this.right ? marginRight11 : "auto",
                    "max-width": this.maxWidth
                });
                if (this.left && marginLeft11) $panelBody11.transition({
                    "margin-left": 0
                }, flags11.time || 300);
                if (this.right && marginRight11) $panelBody11.transition({
                    "margin-right": 0
                }, flags11.time || 300);
            }
        },
        html: function(content11) {
            var panelIndex11 = content11.indexOf('<div class="pfx-panel">');
            if (panelIndex11 >= 0) {
                content11 = content11.substr(panelIndex11 + 23);
                content11 = content11.substr(0, content11.lastIndexOf("</div>"));
            }
            this.$el.html(content11);
            if (this.source && this.isPopup) this.$(".pfx-title").remove();
            else if (this.leftmost) this.$(".pfx-backbutton").show();
            else this.$(".pfx-backbutton").hide();
            this.$(".pfx-body").css({
                "margin-left": this.left ? 0 : "auto",
                "margin-right": this.right ? 0 : "auto",
                "max-width": this.maxWidth
            });
            this.updateBackButton();
            this.updateContent();
        },
        updateBackButton: function() {
            if (this.sourcePanel) {
                if (this.sourcePanel.shortTitle) this.$(".pfx-backbutton").html(this.app.backButtonPrefix + this.sourcePanel.shortTitle.replace(/</g, "&lt;"));
                this.$(".pfx-backbutton").attr("href", this.app.root + this.sourcePanel.fragment);
            }
        },
        updateContent: function() {},
        show: function() {
            this.hidden = false;
            this.load();
            this.$el.css("display", "block");
        },
        hide: function() {
            this.hidden = true;
            this.$el.css("display", "none");
        },
        load: function() {
            // placeholder loader: does nothing
            this.loaded = true;
            this.whenLoadedQueueFlush();
        },
        whenLoadedQueue: null,
        whenLoaded: function(callback11) {
            if (this.loaded === true) callback11.call(this);
            else {
                if (!this.whenLoadedQueue) this.whenLoadedQueue = [];
                this.whenLoadedQueue.push(callback11);
            }
        },
        whenLoadedQueueFlush: function() {
            if (this.loaded !== true || !this.whenLoadedQueue) return;
            for(var i11 = 0; i11 < this.whenLoadedQueue.length; i11++)this.whenLoadedQueue[i11].call(this);
            this.whenLoadedQueue = null;
        },
        reload: function() {
            this.loaded = false;
            if (!this.hidden) this.load();
        },
        handleNavigation: function(e11) {
            if (e11.cmdKey || e11.metaKey || e11.ctrlKey) return;
            var target11 = $(e11.currentTarget);
            var linkTarget11 = target11.data("target");
            var linkAction11 = target11.data("action");
            var linkHref11 = target11.data("href") || target11.attr("href") || target11.attr("action");
            var formMethod11 = "";
            if (target11[0].tagName.toUpperCase() === "FORM") {
                formMethod11 = "GET";
                if ((target11.attr("method") || "").toUpperCase() === "POST") formMethod11 = "POST";
                target11.find("button[type=submit]").attr("disabled", "disabled").text("Loading...");
            }
            // TODO: finish
            if (linkAction11) {
                e11.preventDefault();
                e11.stopImmediatePropagation();
                this[linkAction11].call(this, e11);
            } else if (linkTarget11 === "replace" && formMethod11) {
                e11.preventDefault();
                e11.stopImmediatePropagation();
                var data11 = target11.serialize();
                this.ajax(linkHref11, data11, formMethod11);
            } else if (linkTarget11) {
                e11.preventDefault();
                e11.stopImmediatePropagation();
                switch(linkTarget11){
                    case "back":
                        this.app.go(linkHref11, -1);
                        break;
                    case "push":
                        this.app.go(linkHref11, this, false, target11);
                        break;
                    case "replace":
                        this.app.go(linkHref11, this, true);
                        break;
                }
            }
        },
        post: function(target11, data11) {
            return this.ajax(target11, data11, "POST");
        },
        get: function(target11, data11) {
            return this.ajax(target11, data11);
        },
        ajax: function(target11, data11, method11) {
            if (!target11) target11 = this.app.root + this.fragment;
            return $.ajax(target11 + "?output=html", {
                type: method11 || GET,
                dataType: "text",
                data: data11
            }).done((function(response11) {
                this.html(response11);
            }).bind(this));
        },
        setSource: function(newSource11, newSourcePanel11) {
            if (this.source) {
                this.source.removeClass("cur");
                if (this.source[0].tagName.toUpperCase() === "BUTTON") this.source[0].disabled = false;
            }
            this.source = newSource11;
            this.sourcePanel = newSourcePanel11;
            if (this.source) {
                this.source.addClass("cur");
                if (this.source[0].tagName.toUpperCase() === "BUTTON") this.source[0].disabled = true;
            }
        },
        remove: function() {
            Backbone.View.prototype.remove.apply(this, arguments);
            if (this.source) {
                this.source.removeClass("cur");
                if (this.source[0].tagName.toUpperCase() === "BUTTON") this.source[0].disabled = false;
            }
            delete this.sourcePanel;
            if (this.bgElem) this.bgElem.remove();
            this.app = null; // remove possible circular references for GC
        },
        close: function() {},
        url: ""
    });
    Panels.Popup = Panel.extend({
        isPopup: true,
        close: function() {
            this.app.closePopup();
        }
    });
    Panels.Topbar = View.extend({
        constructor: function(options11) {
            // init 1
            var initialize11 = this.initialize;
            this.initialize = function() {};
            View.prototype.constructor.call(this, {
                el: options11.el
            });
            this.app = options11.app;
            // init 2
            if (!this.height) this.height = this.$el.height();
            initialize11.apply(this);
        },
        app: null,
        height: 0
    });
    Panels.StaticPanel = Panel.extend({
        constructor: function() {
            Panel.prototype.constructor.apply(this, arguments);
        },
        load: function() {
            if (this.loaded) return;
            this.loaded = "loading";
            this.$el.prepend('<p class="pfx-loading"><em>Loading...</em></p>');
            $.get(this.app.root + this.fragment + (this.fragment.indexOf("?") >= 0 ? "&" : "?") + "output=html").done((function(content11) {
                this.html(content11);
                this.loaded = true;
                this.whenLoadedQueueFlush();
            }).bind(this));
        }
    });
}).call(window);
/*!
 * jQuery Transit - CSS3 transitions and transformations
 * (c) 2011-2012 Rico Sta. Cruz <rico@ricostacruz.com>
 * MIT Licensed.
 *
 * http://ricostacruz.com/jquery.transit
 * http://github.com/rstacruz/jquery.transit
 */ (function(k11) {
    k11.transit = {
        version: "0.9.9",
        propertyMap: {
            marginLeft: "margin",
            marginRight: "margin",
            marginBottom: "margin",
            marginTop: "margin",
            paddingLeft: "padding",
            paddingRight: "padding",
            paddingBottom: "padding",
            paddingTop: "padding"
        },
        enabled: true,
        useTransitionEnd: false
    };
    var d11 = document.createElement("div");
    var q11 = {};
    function b11(v11) {
        if (v11 in d11.style) return v11;
        var u11 = [
            "Moz",
            "Webkit",
            "O",
            "ms"
        ];
        var r11 = v11.charAt(0).toUpperCase() + v11.substr(1);
        if (v11 in d11.style) return v11;
        for(var t11 = 0; t11 < u11.length; ++t11){
            var s11 = u11[t11] + r11;
            if (s11 in d11.style) return s11;
        }
    }
    function e11() {
        d11.style[q11.transform] = "";
        d11.style[q11.transform] = "rotateY(90deg)";
        return d11.style[q11.transform] !== "";
    }
    var a11 = navigator.userAgent.toLowerCase().indexOf("chrome") > -1;
    q11.transition = b11("transition");
    q11.transitionDelay = b11("transitionDelay");
    q11.transform = b11("transform");
    q11.transformOrigin = b11("transformOrigin");
    q11.transform3d = e11();
    var i11 = {
        transition: "transitionEnd",
        MozTransition: "transitionend",
        OTransition: "oTransitionEnd",
        WebkitTransition: "webkitTransitionEnd",
        msTransition: "MSTransitionEnd"
    };
    var f11 = q11.transitionEnd = i11[q11.transition] || null;
    for(var p11 in q11)if (q11.hasOwnProperty(p11) && typeof k11.support[p11] === "undefined") k11.support[p11] = q11[p11];
    d11 = null;
    k11.cssEase = {
        _default: "ease",
        "in": "ease-in",
        out: "ease-out",
        "in-out": "ease-in-out",
        snap: "cubic-bezier(0,1,.5,1)",
        easeOutCubic: "cubic-bezier(.215,.61,.355,1)",
        easeInOutCubic: "cubic-bezier(.645,.045,.355,1)",
        easeInCirc: "cubic-bezier(.6,.04,.98,.335)",
        easeOutCirc: "cubic-bezier(.075,.82,.165,1)",
        easeInOutCirc: "cubic-bezier(.785,.135,.15,.86)",
        easeInExpo: "cubic-bezier(.95,.05,.795,.035)",
        easeOutExpo: "cubic-bezier(.19,1,.22,1)",
        easeInOutExpo: "cubic-bezier(1,0,0,1)",
        easeInQuad: "cubic-bezier(.55,.085,.68,.53)",
        easeOutQuad: "cubic-bezier(.25,.46,.45,.94)",
        easeInOutQuad: "cubic-bezier(.455,.03,.515,.955)",
        easeInQuart: "cubic-bezier(.895,.03,.685,.22)",
        easeOutQuart: "cubic-bezier(.165,.84,.44,1)",
        easeInOutQuart: "cubic-bezier(.77,0,.175,1)",
        easeInQuint: "cubic-bezier(.755,.05,.855,.06)",
        easeOutQuint: "cubic-bezier(.23,1,.32,1)",
        easeInOutQuint: "cubic-bezier(.86,0,.07,1)",
        easeInSine: "cubic-bezier(.47,0,.745,.715)",
        easeOutSine: "cubic-bezier(.39,.575,.565,1)",
        easeInOutSine: "cubic-bezier(.445,.05,.55,.95)",
        easeInBack: "cubic-bezier(.6,-.28,.735,.045)",
        easeOutBack: "cubic-bezier(.175, .885,.32,1.275)",
        easeInOutBack: "cubic-bezier(.68,-.55,.265,1.55)"
    };
    k11.cssHooks["transit:transform"] = {
        get: function(r11) {
            return k11(r11).data("transform") || new j11();
        },
        set: function(s11, r11) {
            var t11 = r11;
            if (!(t11 instanceof j11)) t11 = new j11(t11);
            if (q11.transform === "WebkitTransform" && !a11) s11.style[q11.transform] = t11.toString(true);
            else s11.style[q11.transform] = t11.toString();
            k11(s11).data("transform", t11);
        }
    };
    k11.cssHooks.transform = {
        set: k11.cssHooks["transit:transform"].set
    };
    if (k11.fn.jquery < "1.8") {
        k11.cssHooks.transformOrigin = {
            get: function(r11) {
                return r11.style[q11.transformOrigin];
            },
            set: function(r11, s11) {
                r11.style[q11.transformOrigin] = s11;
            }
        };
        k11.cssHooks.transition = {
            get: function(r11) {
                return r11.style[q11.transition];
            },
            set: function(r11, s11) {
                r11.style[q11.transition] = s11;
            }
        };
    }
    n11("scale");
    n11("translate");
    n11("rotate");
    n11("rotateX");
    n11("rotateY");
    n11("rotate3d");
    n11("perspective");
    n11("skewX");
    n11("skewY");
    n11("x", true);
    n11("y", true);
    function j11(r11) {
        if (typeof r11 === "string") this.parse(r11);
        return this;
    }
    j11.prototype = {
        setFromString: function(t11, s11) {
            var r11 = typeof s11 === "string" ? s11.split(",") : s11.constructor === Array ? s11 : [
                s11
            ];
            r11.unshift(t11);
            j11.prototype.set.apply(this, r11);
        },
        set: function(s11) {
            var r11 = Array.prototype.slice.apply(arguments, [
                1
            ]);
            if (this.setter[s11]) this.setter[s11].apply(this, r11);
            else this[s11] = r11.join(",");
        },
        get: function(r11) {
            if (this.getter[r11]) return this.getter[r11].apply(this);
            else return this[r11] || 0;
        },
        setter: {
            rotate: function(r11) {
                this.rotate = o11(r11, "deg");
            },
            rotateX: function(r11) {
                this.rotateX = o11(r11, "deg");
            },
            rotateY: function(r11) {
                this.rotateY = o11(r11, "deg");
            },
            scale: function(r11, s11) {
                if (s11 === undefined) s11 = r11;
                this.scale = r11 + "," + s11;
            },
            skewX: function(r11) {
                this.skewX = o11(r11, "deg");
            },
            skewY: function(r11) {
                this.skewY = o11(r11, "deg");
            },
            perspective: function(r11) {
                this.perspective = o11(r11, "px");
            },
            x: function(r11) {
                this.set("translate", r11, null);
            },
            y: function(r11) {
                this.set("translate", null, r11);
            },
            translate: function(r11, s11) {
                if (this._translateX === undefined) this._translateX = 0;
                if (this._translateY === undefined) this._translateY = 0;
                if (r11 !== null && r11 !== undefined) this._translateX = o11(r11, "px");
                if (s11 !== null && s11 !== undefined) this._translateY = o11(s11, "px");
                this.translate = this._translateX + "," + this._translateY;
            }
        },
        getter: {
            x: function() {
                return this._translateX || 0;
            },
            y: function() {
                return this._translateY || 0;
            },
            scale: function() {
                var r11 = (this.scale || "1,1").split(",");
                if (r11[0]) r11[0] = parseFloat(r11[0]);
                if (r11[1]) r11[1] = parseFloat(r11[1]);
                return r11[0] === r11[1] ? r11[0] : r11;
            },
            rotate3d: function() {
                var t11 = (this.rotate3d || "0,0,0,0deg").split(",");
                for(var r11 = 0; r11 <= 3; ++r11)if (t11[r11]) t11[r11] = parseFloat(t11[r11]);
                if (t11[3]) t11[3] = o11(t11[3], "deg");
                return t11;
            }
        },
        parse: function(s11) {
            var r11 = this;
            s11.replace(/([a-zA-Z0-9]+)\((.*?)\)/g, function(t11, v11, u11) {
                r11.setFromString(v11, u11);
            });
        },
        toString: function(t11) {
            var s11 = [];
            for(var r11 in this)if (this.hasOwnProperty(r11)) {
                if (!q11.transform3d && (r11 === "rotateX" || r11 === "rotateY" || r11 === "perspective" || r11 === "transformOrigin")) continue;
                if (r11[0] !== "_") {
                    if (t11 && r11 === "scale") s11.push(r11 + "3d(" + this[r11] + ",1)");
                    else if (t11 && r11 === "translate") s11.push(r11 + "3d(" + this[r11] + ",0)");
                    else s11.push(r11 + "(" + this[r11] + ")");
                }
            }
            return s11.join(" ");
        }
    };
    function m11(s11, r11, t11) {
        if (r11 === true) s11.queue(t11);
        else if (r11) s11.queue(r11, t11);
        else t11();
    }
    function h11(s11) {
        var r11 = [];
        k11.each(s11, function(t11) {
            t11 = k11.camelCase(t11);
            t11 = k11.transit.propertyMap[t11] || k11.cssProps[t11] || t11;
            t11 = c11(t11);
            if (k11.inArray(t11, r11) === -1) r11.push(t11);
        });
        return r11;
    }
    function g11(s11, v11, x11, r11) {
        var t11 = h11(s11);
        if (k11.cssEase[x11]) x11 = k11.cssEase[x11];
        var w11 = "" + l11(v11) + " " + x11;
        if (parseInt(r11, 10) > 0) w11 += " " + l11(r11);
        var u11 = [];
        k11.each(t11, function(z11, y11) {
            u11.push(y11 + " " + w11);
        });
        return u11.join(", ");
    }
    k11.fn.transition = k11.fn.transit = function(z11, s11, y11, C11) {
        var D11 = this;
        var u11 = 0;
        var w11 = true;
        if (typeof s11 === "function") {
            C11 = s11;
            s11 = undefined;
        }
        if (typeof y11 === "function") {
            C11 = y11;
            y11 = undefined;
        }
        if (typeof z11.easing !== "undefined") {
            y11 = z11.easing;
            delete z11.easing;
        }
        if (typeof z11.duration !== "undefined") {
            s11 = z11.duration;
            delete z11.duration;
        }
        if (typeof z11.complete !== "undefined") {
            C11 = z11.complete;
            delete z11.complete;
        }
        if (typeof z11.queue !== "undefined") {
            w11 = z11.queue;
            delete z11.queue;
        }
        if (typeof z11.delay !== "undefined") {
            u11 = z11.delay;
            delete z11.delay;
        }
        if (typeof s11 === "undefined") s11 = k11.fx.speeds._default;
        if (typeof y11 === "undefined") y11 = k11.cssEase._default;
        s11 = l11(s11);
        var E11 = g11(z11, s11, y11, u11);
        var B11 = k11.transit.enabled && q11.transition;
        var t11 = B11 ? parseInt(s11, 10) + parseInt(u11, 10) : 0;
        if (t11 === 0) {
            var A11 = function(F11) {
                D11.css(z11);
                if (C11) C11.apply(D11);
                if (F11) F11();
            };
            m11(D11, w11, A11);
            return D11;
        }
        var x11 = {};
        var r11 = function(H11) {
            var G11 = false;
            var F11 = function() {
                if (G11) D11.unbind(f11, F11);
                if (t11 > 0) D11.each(function() {
                    this.style[q11.transition] = x11[this] || null;
                });
                if (typeof C11 === "function") C11.apply(D11);
                if (typeof H11 === "function") H11();
            };
            if (t11 > 0 && f11 && k11.transit.useTransitionEnd) {
                G11 = true;
                D11.bind(f11, F11);
            } else window.setTimeout(F11, t11);
            D11.each(function() {
                if (t11 > 0) this.style[q11.transition] = E11;
                k11(this).css(z11);
            });
        };
        var v11 = function(F11) {
            this.offsetWidth;
            r11(F11);
        };
        m11(D11, w11, v11);
        return this;
    };
    function n11(s11, r11) {
        if (!r11) k11.cssNumber[s11] = true;
        k11.transit.propertyMap[s11] = q11.transform;
        k11.cssHooks[s11] = {
            get: function(v11) {
                var u11 = k11(v11).css("transit:transform");
                return u11.get(s11);
            },
            set: function(v11, w11) {
                var u11 = k11(v11).css("transit:transform");
                u11.setFromString(s11, w11);
                k11(v11).css({
                    "transit:transform": u11
                });
            }
        };
    }
    function c11(r11) {
        return r11.replace(/([A-Z])/g, function(s11) {
            return "-" + s11.toLowerCase();
        });
    }
    function o11(s11, r11) {
        if (typeof s11 === "string" && !s11.match(/^[\-0-9\.]+$/)) return s11;
        else return "" + s11 + r11;
    }
    function l11(s11) {
        var r11 = s11;
        if (k11.fx.speeds[r11]) r11 = k11.fx.speeds[r11];
        return o11(r11, "ms");
    }
    k11.transit.getTransitionValue = g11;
})(jQuery);
if (!jQuery.support.transition) jQuery.fn.transition = jQuery.fn.animate;

});


parcelRequire("6Vrnd");

//# sourceMappingURL=index.ae011f95.js.map
